import { toast } from 'sonner';

/**
 * Handles client-side form validation errors from `react-hook-form`.
 * Shows a toast notification and logs the error to the console.
 *
 * @example
 * ```tsx
 * <form onSubmit={form.handleSubmit(handleValidSubmit, handleSubmitErrors)}>
 * ```
 */
export const handleSubmitErrors = (error: unknown) => {
  console.error(error);
  toast.error('Please correct the form errors');
};
